import {LinkText} from '@/components/atoms';
import {formatDateToLocalYYYYMMDD} from '@/utility/dateHelper';
import {ROUTES} from '@/utils/constants/routesConstants';

// Avoids a regex-based suffix strip (flagged as a ReDoS security hotspot).
const stripTrailingTargetWord = (value = '') => {
  const trimmed = value.trim();
  return trimmed.toLowerCase().endsWith('target')
    ? trimmed.slice(0, trimmed.length - 'target'.length).trimEnd()
    : trimmed;
};

// The report API only has data for targets that have started or finished.
const REPORT_AVAILABLE_STATUSES = new Set(['in-progress', 'completed']);
const isReportAvailable = (status) =>
  REPORT_AVAILABLE_STATUSES.has(status?.toLowerCase());

export const cellDataMapperObj = (navigate, onReportDownload) => ({
  targetName: {
    cellData: ({row: {original} = {}}) => (
      <LinkText
        text={original?.targetName || '\u2014'}
        id={`perfect-store-${original?.id}`}
        handleClick={() =>
          navigate(
            ROUTES.PERFECT_STORE_DETAIL.replace(
              ':id',
              encodeURIComponent(original?.id)
            )
          )
        }
      />
    )
  },
  storeCount: {
    cellData: ({row: {original} = {}}) => (
      <div>{original?.storeCount ?? '\u2014'}</div>
    )
  },
  percentAchievedTarget: {
    cellData: ({row: {original} = {}}) => (
      <div>
        {original?.percentAchievedTarget != null
          ? `${original.percentAchievedTarget}%`
          : '\u2014'}
      </div>
    )
  },
  pointsAwarded: {
    cellData: ({row: {original} = {}}) => (
      <div>{original?.pointsAwarded ?? '\u2014'}</div>
    )
  },
  status: {
    cellData: ({row: {original} = {}}) => (
      <div>
        {original?.status ?? '\u2014'}
        {original?.status === 'Visit List Uploaded' &&
          original?.visitListUploadedDate && (
            <div>
              {formatDateToLocalYYYYMMDD(original.visitListUploadedDate)}
            </div>
          )}
      </div>
    )
  },
  startDate: {
    cellData: ({row: {original} = {}}) => (
      <div>{formatDateToLocalYYYYMMDD(original?.startDate) || '\u2014'}</div>
    )
  },
  endDate: {
    cellData: ({row: {original} = {}}) => (
      <div>{formatDateToLocalYYYYMMDD(original?.endDate) || '\u2014'}</div>
    )
  },
  reportUrl: {
    cellData: ({row: {original} = {}}) => {
      const reportEnabled = isReportAvailable(original?.status);
      return (
        <LinkText
          text={
            original?.targetType
              ? `${stripTrailingTargetWord(original.targetName)} Report`
              : 'Target Report'
          }
          id={`perfect-store-report-${original?.id}`}
          isPaddingHidden={true}
          disabled={!reportEnabled}
          handleClick={() =>
            reportEnabled &&
            onReportDownload(original?.id, original?.targetName)
          }
        />
      );
    }
  },
  updatedAt: {
    cellData: ({row: {original} = {}}) => (
      <div>{formatDateToLocalYYYYMMDD(original?.updatedAt) || '\u2014'}</div>
    )
  },
  updatedBy: {
    cellData: ({row: {original} = {}}) => (
      <div>{original?.updatedBy ?? '\u2014'}</div>
    )
  }
});
